<template>
  <div>
    <gamification-section />

    <p>Quick Access</p>
    <v-card elevation="2" class="mb-4 mt-6">
      <v-card-text class="py-0">
        <v-col cols="12" sm="12" md="12">
          <v-row>
            <v-col sm="1" md="3">
              <div class="img-pad">
                <div @click="$router.push('markets')" class="img">
                  <v-img class="stock_img" :src="stock_img" contain> </v-img>
                </div>
                <div class="img-text">Markets</div>
              </div>
            </v-col>
            <v-divider class="divider" vertical> </v-divider>
            <v-col sm="1" md="3">
              <div class="img-pad">
                <div class="img" @click="$router.push('news')">
                  <v-img class="news_img" :src="news_img" contain> </v-img>
                </div>
                <div class="img-text">News</div>
              </div>
            </v-col>
            <v-divider class="divider" vertical> </v-divider>

            <v-col sm="1" md="3">
              <div class="img-pad">
                <div class="img" @click="$router.push('economic-calendar')">
                  <v-img class="calendar_img" :src="calendar_img" contain>
                  </v-img>
                </div>
                <div class="img-text">Economic<br />Calendar</div>
              </div>
            </v-col>
            <v-divider class="divider" vertical> </v-divider>

            <v-col sm="1" md="3">
              <div class="img-pad">
                <!-- <router-link to="webinars"> -->
                <div
                  class="img"
                  @click="
                    $router.push({
                      name: 'WebinarsPage',
                    })
                  "
                >
                  <v-img class="webinar_img" :src="webinar_img" contain>
                  </v-img>
                </div>
                <!-- </router-link> -->
                <div class="img-text">Webinars</div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="1" md="3">
              <div class="img-pad">
                <div
                  @click="$router.push({ name: 'premiumGroups' })"
                  class="img"
                >
                  <v-img class="stock_img" :src="premium_trade_icon" contain>
                  </v-img>
                </div>
                <div class="img-text">Premium <br />Trades</div>
              </div>
            </v-col>
            <v-divider class="divider" vertical> </v-divider>
            <v-col sm="1" md="3">
              <div class="img-pad">
                <!-- on click of below div add @click="$router.push('reports')" ones the page is made -->
                <div class="img" @click="$router.push('reports')">
                  <v-img class="news_img" :src="research_icon" contain> </v-img>
                </div>
                <div class="img-text">
                  Research <br />
                  Reports
                </div>
              </div>
            </v-col>
            <v-divider class="divider" vertical> </v-divider>

            <v-col sm="1" md="3">
              <div class="img-pad">
                <div class="img" @click="importPortfolio">
                  <v-img class="calendar_img" :src="portfolio_icon" contain>
                  </v-img>
                </div>
                <div class="img-text">Portfolio<br />Review</div>
              </div>
            </v-col>
            <v-divider class="divider" vertical> </v-divider>

            <v-col sm="1" md="3">
              <div class="img-pad">
                <div class="img" @click="openCourses">
                  <v-img class="webinar_img" :src="trading_img" contain>
                  </v-img>
                </div>

                <div class="img-text">Trading <br />Courses</div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-card-text>
    </v-card>
    <UpcomingTradeList
      class="mt-8"
      :class="$vuetify.breakpoint.xsOnly ? 'pb-10 mb-10' : 'pb-5'"
      @add-trade="addTrade"
    />
    <div>
      <div class="mt-12 font-weight-bold black--text" style="font-size: 18px">
        <v-row>
          <v-col v-if="premium_groups.length != 0" cols="12" class="px-4">
            <div class="d-flex justify-space-between">
              <div>Premium Groups</div>
              <div
                @click="$router.push({ name: 'premiumGroups' })"
                class="view-all"
              >
                View all
              </div>
            </div>
          </v-col>
          <v-col v-if="group_loading" cols="12" class="px-4">
            <div class="d-flex justify-space-between">
              <div>Premium Groups</div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" style="overflow-x: scroll; width: 100%">
            <v-row class="ma-0" v-if="group_loading">
              <v-col cols="12" md="4" sm="12" v-for="item in 3" :key="item">
                <v-card class="mt-2">
                  <v-skeleton-loader
                    :type="
                      $vuetify.breakpoint.xsOnly ? 'article' : 'image, article'
                    "
                  />
                </v-card>
              </v-col>
            </v-row>
            <group-horizontal-list
              v-else-if="premium_groups.length"
              :groups="premium_groups"
              :loading="group_loading"
              class="mt-4 mx-1 mb-3"
            ></group-horizontal-list>
          </v-col>
        </v-row>
      </div>

      <v-dialog
        v-model="group_loading"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        class="fullscreen"
      >
        <loadingScreen />
      </v-dialog>

      <p class="mt-9">Trending Stocks</p>
      <StocksList />

      <!-- <v-img
        :class="[
          $vuetify.breakpoint.smAndDown
            ? 'mb-4 mt-6 no-margin'
            : 'mb-4 mt-6 trending_banner',
        ]"
        :src="$vuetify.breakpoint.smAndDown ? banner_mobile : trending_banner"
        contain
        @click="importPortfolio"
      >
      </v-img> -->
      <div class="mt-6">
        <BannerCourosal />
      </div>

      <PerformingTraderList
        :class="$vuetify.breakpoint.xsOnly ? 'mt-4' : 'mt-8'"
      />
      <ProfitableTradeList
        :class="$vuetify.breakpoint.xsOnly ? 'mt-7' : 'mt-6'"
        @add-trade="addTrade"
      />
      <div
        class="font-weight-bold black--text"
        :class="$vuetify.breakpoint.xsOnly ? 'mt-7' : 'my-3 mt-6'"
        style="font-size: 18px"
        v-if="trending_videos.length != 0"
      >
        <div class="d-flex justify-space-between">
          <div>Trending Videos</div>
          <div
            @click="$router.push({ name: 'VideoCourseList' })"
            class="view-all"
          >
            View all
          </div>
        </div>
        <v-row class="ma-0" v-if="loadingTrendingVideos">
          <v-col cols="6" md="4" v-for="item in 3" :key="item">
            <v-card class="mt-2">
              <v-skeleton-loader type="image, article" />
            </v-card>
          </v-col>
        </v-row>
        <div
          class="d-flex"
          style="overflow-x: scroll; width: 100%; overflow-y: hidden"
          :class="$vuetify.breakpoint.xsOnly ? 'mt-2' : 'mt-5'"
        >
          <div
            v-for="(item, index) of trending_videos"
            :key="index"
            class="mr-4 mt-3 mb-3"
            :class="$vuetify.breakpoint.xsOnly ? 'mb-3' : ''"
          >
            <VideoCard
              :value="item"
              :user_id="parseInt(item.profile.user)"
              style="width: 300px"
            />
          </div>
        </div>
        <!-- <v-btn
          color="#ffff"
          block
          class="primary--text mt-4 text-capitalize"
          @click="$router.push({ name: 'VideoCourseList' })"
          >See All Videos</v-btn
        > -->
        <!-- :class="$vuetify.breakpoint.xsOnly ? 'mb-10' : ''" -->
      </div>

      <!-- <PerformingTraderList class="mt-12" /> -->
    </div>
  </div>
</template>

<script>
import Axios from "@/api/BaseAxios.js";
import ProfitableTradeList from "@/components/Trending/ProfitableTrade/ProfitableTradeList.vue";
import PerformingTraderList from "@/components/Trending/PerformingTrader/PerformingTraderList.vue";
import UpcomingTradeList from "@/components/Trending/UpcomingTrade/UpcomingTradeList.vue";
import { mapActions } from "vuex";
import VideoCard from "@/components/VideoCourse/VideoCard/VideoCard.vue";
import StocksList from "@/components/Trending/TrendingStocks/StocksList.vue";
import apiUrl from "@/common/apiUrl";
import jwt_decode from "jwt-decode";
import commonFunctions from "@/common/commonFunctions";
import loadingScreen from "@/components/LoadingScreen";
import BannerCourosal from "@/components/Trending/Banners/bannerCourosal.vue";
import GamificationSection from "./gamificationSection.vue";
export default {
  components: {
    BannerCourosal,
    ProfitableTradeList,
    PerformingTraderList,
    UpcomingTradeList,
    StocksList,
    // GroupHorizontalList: () => import("@/components/GroupHorizontalList.vue"),
    GroupHorizontalList: () =>
      import("@/components/GroupHorizontalListNew.vue"),
    VideoCard,
    loadingScreen,
    GamificationSection,
  },
  data: () => ({
    stock_img: require("/src/assets/images/trending/stock.svg"),
    news_img: require("/src/assets/images/trending/news.svg"),
    calendar_img: require("/src/assets/images/trending/calendar.svg"),
    webinar_img: require("/src/assets/images/trending/webinar.svg"),
    trending_banner: require("/src/assets/images/trending/banner.svg"),
    banner_mobile: require("/src/assets/images/trending/banner_mobile.svg"),
    premium_trade_icon: require("/src/assets/images/trending/premiumTradeIcon.svg"),
    research_icon: require("/src/assets/images/trending/researchIcon.svg"),
    portfolio_icon: require("/src/assets/images/trending/portfolioIcon.svg"),
    trading_img: require("/src/assets/images/trending/tradingIcon.svg"),
    video_loading: true,
    influencers_list: [],
    duration: null,
    status: null,
    buy_sell: null,
    group_loading: false,
    sorts: [],
    trending_videos: [],
    loadingTrendingVideos: false,
    page: 1,
    numPages: 1,
    influencerPage: 1,
    influencerNumPages: 1,
    trades: [],
    hide: true,
    influencerHide: false,
    is_Intersecting: false,
    trade_form_data: {
      flag: false,
      id: null,
      trade_data: {},
      trade_edit: false,
    },

    premium_groups: [],
  }),
  mounted() {
    this.getPremiumGroups();
    this.getTrendingVideos();
  },
  methods: {
    ...mapActions({
      toggleTradeModal: "tradeData/toggleModal",
      toggleAddTradeModal: "addTrade/toggleTradeModal",
    }),
    addTrade() {
      this.trade_form_data.flag = true;
      this.toggleAddTradeModal({ show: true, type: "add" });
    },
    openCourses() {
      window.open("https://courses.covesto.in/", "_blank");
    },
    getTradesList(item) {
      const successHandler = (res) => {
        if (item == "append") {
          res.data.result.forEach((item) => {
            this.trades.push(item);
          });
          this.numPages = res.data.num;
          this.tradesLoading = false;
        } else {
          this.trades = res.data.result;
          this.tradesLoading = false;
          this.numPages = res.data.num;
        }
      };
      const user_id = localStorage.getItem("user_id");
      const errorHandler = (err) => {
        console.log(err);
      };
      Axios.request_GET(
        `api/trade/all-trade-list/${user_id}/${this.page}/${
          this.status == "" ? null : this.status
        }/${this.buy_sell == "" ? null : this.buy_sell}/${
          this.duration == "" ? null : this.duration
        }`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    filterTrades() {
      this.page = 1;
      this.getTradesList();
    },
    reloadTrades() {
      this.page = 1;
      this.getTradesList();
    },

    onIntersect(entries) {
      this.hide = true;
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.page += 1;
          if (this.page <= this.numPages) {
            this.getTradesList("append");
          } else {
            this.hide = false;
          }
        }
      });
    },

    reviewTrade(data) {
      this.trade_review_data.trade_data = data;
      this.trade_review_data.flag = true;
    },
    tradeEdit(data) {
      this.trade_form_data.trade_data = data;
      this.trade_form_data.trade_edit = true;
      this.trade_form_data.flag = true;
    },
    shareTrade(data) {
      navigator.share(
        {
          title: "Covesto",
          text: `Hello, ${data.posted_by_name} has shared a trade recommendation on Covesto.${data.trade_type} ${data.security_name}
            To know more details and get live updates, follow the trade at `,
          url: `https://covesto.in/trade/${data.id}/${data.security.name}`,
        },
        {
          skype: false,
          pinterest: false,
          print: false,
          sms: false,
        }
      );
      this.getTradeList(0);
    },
    getPremiumGroups() {
      this.group_loading = true;
      const successHandler = (res) => {
        this.premium_groups = res.data.premium_groups;
        this.group_loading = false;
      };
      const failureHandler = () => {
        this.group_loading = false;
      };
      let formData = {};
      formData["detail_count"] = 5;
      Axios.request_GET(
        "/api/premium-groups",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    getTrendingVideos() {
      this.loadingTrendingVideos = true;
      const successHandler = (res) => {
        this.trending_videos = res.data.trending_videos;
        this.loadingTrendingVideos = false;
      };
      const failureHandler = () => {
        this.loadingTrendingVideos = false;
      };
      let formData = {};
      formData["detail_count"] = 5;
      formData["page_number"] = 1;
      Axios.request_GET(
        "/video/trending-videos/",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    importPortfolio() {
      // Redirect to the /trading page after success
      this.$router.push("/trading");
      console.log("image clicked");
      //this.eventBus.$emit("ImportHoldings")
      //this.$root.$refs.importPortfolio.initialImport
      let config = {};
      config["url"] = apiUrl.INTEGRATION_SMALL_CASE_IMPORT;
      config["method"] = "post";
      this.tempAxios(config)
        .then((res) => {
          //   console.log(res);
          this.initiateSmallcaseSdk(
            res.data.auth_token,
            res.data.resp.transactionId
          );
        })
        .catch((err) => {
          this.snackBar({
            text: err,
            color: "error",
            timeout: 4500,
          });
        });
    },
    initiateSmallcaseSdk(authToken, transactionId) {
      const gatewayInstance = new window.scDK({
        // ! Use valid gateway name here
        gateway: "covesto",
        /*
         * ! Use valid auth token
         * Details - https://developers.gateway.smallcase.com/docs/getting-started#broker-identification
         */
        smallcaseAuthToken: authToken,
        config: {
          // Should allow after market orders?
          amo: true,
        },
      });
      gatewayInstance
        .triggerTransaction({
          // ! Use valid transactionId here
          transactionId: transactionId,
        })
        .then((txnResponse) => {
          /*
           * Gateway flow ended after order placement
           * Response structure & example - https://developers.gateway.smallcase.com/docs/transaction-response
           */
          //   console.log("received response:", txnResponse);
          this.patchUserDetail(txnResponse);
        })
        .catch((err) => {
          /*
           * Gateway flow ended before order placement
           * Possible errors - https://developers.gateway.smallcase.com/docs/transaction-errors
           */
          console.log("received error:", err.message);
        });
    },
    patchUserDetail(res) {
      const { broker, smallcaseAuthToken, transactionId } = res;
      let decoded_token = jwt_decode(smallcaseAuthToken);
      const { smallcaseAuthId } = decoded_token;
      let config = {};
      let params = {};
      params["user_id"] = this.user_id;
      params["transaction_id"] = transactionId;
      params["auth_id"] = smallcaseAuthId;
      params["broker"] = broker;
      config["url"] = apiUrl.PORTFOLIO_USER_DRTAIL;
      config["method"] = "patch";
      config["params"] = params;
      this.tempAxios(config)
        .then(() => {
          this.getPortfolio(broker);
        })
        .catch((err) => {
          this.snackBar({
            text: err,
            color: "error",
            timeout: 4500,
          });
        });
    },
    getPortfolio(broker) {
      this.loading = true;
      let config = {};
      let params = {};
      let headers = {};
      params["user_id"] = this.user_id;
      if (broker) {
        params["broker"] = broker;
      }
      headers["User-Id"] = commonFunctions.getUserId();
      config["headers"] = headers;
      config["url"] = apiUrl.GET_PORT_FOLIO;
      config["method"] = "get";
      config["params"] = params;

      this.tempAxios(config)

        .then((res) => {
          console.log(res);
          const { positions, holdings, broker, total_pnl, total_pnl_per } =
            res.data;

          // const { positions, holdings, broker, total_pnl, total_pnl_per } = {
          //   id: null,
          //   nseTicker: "YESBANK",
          //   quantity: 10,
          //   averagePrice: 16.4,
          //   LTP: 26.85,
          //   currentValue: 268.5,
          //   PnL: 104.5,
          //   netChange: 63.72,
          //   dailyChange: -0.92,
          //   exchange: "NSE",
          //   prevCurrentValue: 271.0,
          //   public: false,
          // };
          this.broker = broker;

          //positions
          this.positionItems = positions.securities;
          this.positionCount = positions.count;
          this.positionInvestedAmount = positions.investedAmount;
          this.positionCurrentAmount = positions.currentAmount;
          this.positionCurrentPnl = positions.currentPnL;
          this.positionCurrentPnlPercent = positions.currentPnLPer;

          //holdings
          this.holdingItems = holdings.securities;
          this.holdingCount = holdings.count;
          this.holdingInvestedAmount = holdings.investedAmount;
          this.holdingCurrentAmount = holdings.currentAmount;
          this.holdingCurrentPnl = holdings.currentPnL;
          this.holdingCurrentPnlPercent = holdings.currentPnLPer;
          this.holdingDaysPnl = holdings.daysPnL;
          this.holdingDaysPnlPercent = holdings.daysPnLPer;
          this.total_pnl = total_pnl;
          this.total_pnl_percent = total_pnl_per?.toFixed(2);
          this.emitDaysPnl();
          this.loading = false;
          this.emitLoader(false);
          this.$logEvent("banner_import_portfolio");
        })
        .catch((err) => {
          this.snackBar({
            text: err,
            color: "error",
            timeout: 4500,
          });
          this.loading = false;
          this.emitLoader(false);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.fullscreen {
  width: 100vw !important;
  height: 100vh !important;
  margin: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
}
/*.no-margin {
  margin-left: -20px !important;
  margin-right: -4px !important;
}*/
@import "~vuetify/src/styles/styles.sass";

.divider {
  height: 65px;
  margin-top: 30px;
}

div > hr {
  border-radius: 0.625rem;
  background-color: #e3edf9;
}

.trending_banner {
  cursor: pointer;
}

.img-text {
  color: rgba(51, 51, 51, 0.82);
  text-align: center;
  font-family: Avenir;
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.25rem;
  /* 125% */
}

.img-pad {
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.img {
  height: 55px;
  width: 55px;
  padding: 12px;
  background-color: #f2f8ff;
  border-radius: 50%;
  cursor: pointer;
}

.stock_img,
.calendar_img,
.news_img,
.webinar_img {
  padding: 8px;
  background-color: #f2f8ff;
  height: 35px;
  width: 35px;
}

@media only screen and (max-width: 425px) {
  .divider {
    height: 32px;
    margin-top: 14px;
  }

  .img-pad {
    padding: 9px;
  }

  .img {
    height: 40px;
    width: 40px;
    padding: 9px;
  }

  .stock_img,
  .calendar_img,
  .news_img,
  .webinar_img {
    padding: 11px;
    height: 15px;
    width: 20px;
  }

  .img-text {
    font-size: 0.76rem;
  }
}

@media #{map-get($display-breakpoints, 'md-and-up')} {
  .scrollable {
    max-height: 100vh;
    overflow-y: auto;
  }

  .child-1 {
    max-width: 65%;
  }
}

.main-container {
  min-height: calc(100vh - 64px);
  overflow-y: hidden;
  background-color: #f6f7fa;
}

.sort-select {
  border: 1px solid rgba(51, 51, 51, 0.16) !important;
  width: 10px;
  height: 30px;
}

p {
  font-weight: 800;
  font-size: 18px;
}

.view-all {
  cursor: pointer;
  font-family: Avenir;
  font-size: 14px;
  font-weight: 900;
  line-height: 19.12px;
  text-align: left;
  color: #2d8cff;
}

.child-2 {
  background-color: #f6f7fa !important;
  border-left: 1px solid #d9d7d7;
  max-width: 450px;
  flex-grow: 1;
}

.selectBox {
  margin-right: 5px;
  width: 100%;
  height: 55px !important;
}

.add-trade-button {
  text-transform: capitalize;
  letter-spacing: 0px;
  color: white;
}

.floatingIcon {
  display: none;
}

@media all and (max-width: 600px) {
  .add-trade-button {
    display: none;
  }

  .floatingIcon {
    display: inline-flex !important;
  }

  .sort-and-filter {
    text-align: center !important;
  }
}

@media only screen and (max-width: 600px) {
  .add-trade-button {
    display: none;
  }

  .floatingIcon {
    display: inline-flex !important;
  }

  .sort-and-filter {
    text-align: center !important;
  }
}
</style>
